// @ts-nocheck
export const emailRegex = /^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;

export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;

export const nameRegex = /^[A-Za-z\u0410-\u042F\u0430-\u044F ]{1,20}$/;

export const phoneRegex = /^\+?[0-9]{6,20}$/;
export const BG_PHONE_PREFIX = '+359';

/**
 * Normalize whatever a customer types, pastes or the browser autofills into an
 * international number, defaulting to Bulgaria: `0878 603 111`, `00359878603111`,
 * `359878603111` and `+359 (0) 878-603-111` all become `+359878603111`. Never rejects
 * input — the phone field used to silently drop anything not starting with +359, so an
 * autofilled `0878…` left just `+359` in the form and the order failed server-side.
 */
export function normalizePhone(value: string): string {
    // Keep digits and a leading '+' only: drops spaces, dashes, brackets, NBSPs and the
    // invisible direction marks iOS adds when copying from Contacts.
    let phone = (value || '').replace(/[^\d+]/g, '').replace(/(?!^)\+/g, '');

    // Erasing into the prefix (or an empty field) restores the prefix.
    if (BG_PHONE_PREFIX.startsWith(phone)) {
        return BG_PHONE_PREFIX;
    }

    if (phone.startsWith('00')) {
        phone = '+' + phone.slice(2);
    } else if (!phone.startsWith('+')) {
        phone = phone.startsWith('359') ? '+' + phone : BG_PHONE_PREFIX + phone.replace(/^0/, '');
    }

    // The national trunk 0 is redundant after the country code.
    if (phone.startsWith(BG_PHONE_PREFIX + '0')) {
        phone = BG_PHONE_PREFIX + phone.slice(BG_PHONE_PREFIX.length + 1);
    }

    return phone.slice(0, 16); // E.164: '+' and at most 15 digits
}

/** Plausibility check for a normalizePhone() result; the server (libphonenumber) has the final say. */
export function isValidPhone(phone: string): boolean {
    return phone.startsWith(BG_PHONE_PREFIX)
        ? /^\+359\d{8,9}$/.test(phone)
        : /^\+\d{8,15}$/.test(phone);
}
